var map = {
	"./en_us.png": 45609,
	"./es_spa.png": 11322,
	"./ms_my.png": 21600,
	"./yn_yu.png": 8351,
	"./yn_yu2.png": 73821,
	"./zh_cn.png": 44451,
	"./zh_cn22.png": 39759
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99730;